import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mediaKitsApi } from '~/api/mediaKits';
import { logger } from '~/core/logger/logger';
import { MEDIA_KIT } from '~/queries/keys';
import { MEDIA_KITS_DD_SECTION } from '~/screens/PageBuilder';

type payload = {
  name: string;
  blocks: any[];
};
export const useCreateMediaKit = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (newMediaKit: payload) =>
      mediaKitsApi.post('/custom-shareable', {
        ...newMediaKit,
      }),
    onSuccess: () => {
      qc.invalidateQueries([MEDIA_KIT]);
    },
    onError: (error) => {
      logger
        .withMetadata({
          error,
          section: MEDIA_KITS_DD_SECTION,
        })
        .error('Media Kit creation Error');
    },
  });
};
